export default "__VITE_ASSET__C5e8ZLz1__"